import { KPKRequisites } from 'screens/kpk-requisites'

const KPKPage = KPKRequisites

export default KPKPage
